export default function Setting(){
    return(
        <section>Setting</section>
    );
}